/* -----------------------------------------------------------------------------------------------------
  - Created: [31-01-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file Header with action items with routes 
  -------------------------------------------------------------------------------------------------------
*/

import React, { useEffect, useState, useRef } from 'react';
import './HeaderStyle.css';
import { IoIosNotificationsOutline } from "react-icons/io";
import { RxAvatar } from "react-icons/rx";
import { CiUser } from "react-icons/ci";
import { FaPowerOff } from "react-icons/fa6";
import { MdOutlineLockReset } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import Badge from '@mui/material/Badge';
import { getUserData } from '../../utils/localStorage';
import Tooltip from '@mui/material/Tooltip';
import CustomModal from '../custom_components/CustomModal/CustomModal';
import ResetPasswordForm from './HeaderComponents/ResetPasswordForm/ResetPasswordForm';
import Notifications from './HeaderComponents/Notifications/Notifications';
import { IconButton, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotificationsList } from '../../utils/notification.js';
// import { fetchNotificationsList } from '../../utils/notification.js';


const Header = ({ handleLogoutClick, toggleSidebar, isSidebarOpen }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userData = getUserData();

    const { notificationList, unreadCount } = useSelector(state => state.notifications);

    const [isOpen, setIsOpen] = useState(false); //FOR HIDE AND SHOW CONTEXT MENUS
    // State for Profile modal visibility
    // const [showProfile, setShowProfile] = useState(false);

    // State for Change Password modal visibility
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [open, setOpen] = useState(false);
    const [screenWidth, setScreenWidth] = useState('');

    const dropdownRef = useRef(null); // Reference to the dropdown menu


    // Handle click outside of the dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false); // Close the dropdown if clicked outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        // Clean up the event listener when the component is unmounted
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    //FOR GET ALL NOTOFICATIONS
    useEffect(() => {
        fetchNotificationsList(dispatch);
    }, [open]);

    // Function to log the current screen width
    const logScreenWidth = () => {
        setScreenWidth(window.innerWidth)
    };

    useEffect(() => {
        // Log initial width when component mounts
        logScreenWidth();

        // Listen to window resize events
        const handleResize = () => {
            logScreenWidth();
        };

        // Add event listener for resize
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // Empty dependency array means this effect runs once on mount

    const toggleDropdown = () => setIsOpen(!isOpen);

    // Handle Profile logic
    const handleProfileClick = async () => {
        // navigate(`profile/workforce/edit/${userData?.RoleId}/${userData?.Userid}`);
        navigate(`/resources/workforce/view/${userData?.Userid}`, { replace: true });
        toggleDropdown()

    };

    // Handle Change Password logic
    const handleChangePasswordClick = async () => {
        handleResetPassModal()
    };
    // hideandshowresetpasswordform
    const handleResetPassModal = () => {
        setShowChangePassword(prevState => !prevState);
    }
    // hideandshowresetpasswordform
    // const handleProfileModal = () => {
    //     setShowProfile(prevState => !prevState);
    // }

    const handleNotificationModal = () => {
        setOpen(prevState => !prevState);
    }

    // FOR ONLY SHOW 5 ITEMS IN THE NOTIFICATION MODAL
    const notificationsToShow = notificationList?.slice(0, 5);

    const gotoAllNotification = () => {
        setOpen(prevState => !prevState);
        navigate('notification/list');
    }

    return (
        <div className="header-container">
            <button className="menu-toggle-btn" onClick={toggleSidebar} style={{ position: 'relative', zIndex: 2900, fontSize: '2rem', fontWeight: 'bold', border: 'none', background: 'none', color: screenWidth <= 768 && isSidebarOpen ? "rgb(17 24 39)" : "rgb(17 24 39)" }}>
                ☰
            </button>

            <h1></h1>

            <div className="header-right">
                <>
                    <IconButton onClick={() => setOpen(true)}>
                        <Badge badgeContent={unreadCount || 0} color="error">
                            <IoIosNotificationsOutline size={28} />
                        </Badge>
                    </IconButton>
                </>

                <RxAvatar className="avatar-icon" onClick={toggleDropdown} />

                <div className='user-info-container'>
                    <div className='userName-label'>
                        <Tooltip describeChild title={userData?.username}>
                            <span>{userData?.username?.length > 15 ? `${userData?.username.slice(0, 15)}...` : userData?.username}</span>
                        </Tooltip>
                    </div>
                    <div className='userRole-label'>
                        <span>{userData?.RoleName}</span>
                    </div>
                </div>

                {/* Context Dropdown menu */}
                <div className="profile-dropdown" ref={dropdownRef}>
                    {isOpen && (
                        <ul className="profile-dropdown-menu">
                            {/* RoleId = 1 means super admin */}
                            {userData?.RoleId !== 1 && <li className="profile-dropdown-item" onClick={handleProfileClick}>
                                <CiUser className='profile-dropdown-icon' size={20} /> Profile
                            </li>}
                            <li className="profile-dropdown-item" onClick={handleChangePasswordClick}>
                                <MdOutlineLockReset className='profile-dropdown-icon' size={20} /> Change Password
                            </li>
                            <li className="profile-dropdown-item" onClick={handleLogoutClick}>
                                <FaPowerOff className='profile-dropdown-icon' size={20} /> Logout
                            </li>
                        </ul>
                    )}
                </div>



                {/* Modal for Change Password */}
                {showChangePassword && <CustomModal
                    open={showChangePassword}
                    title={"Change Password"}
                    handleClose={handleResetPassModal}
                    body={
                        <ResetPasswordForm
                            userData={userData}
                            handleClose={handleResetPassModal}
                        />
                    }

                />}
                {/* NOTIFICATION MODAL */}
                {open && <CustomModal
                    open={open}
                    title="Notifications"
                    handleClose={handleNotificationModal}
                    body={
                        <>
                            <Notifications
                                notifications={notificationsToShow}
                                handleClose={handleNotificationModal}
                            />

                            {notificationsToShow?.length > 0 && <Button
                                fullWidth
                                variant="contained"

                                sx={{
                                    mt: 2,
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    background: '#006CB8'
                                }}
                                onClick={gotoAllNotification}
                            >
                                View All Notifications
                            </Button>}

                        </>
                    }
                    maxWidth={`900px`}
                />}


                {/* Modal for Viewing Profile */}
                {/* <CustomModal
                    open={showProfile}
                    handleClose={handleProfileModal}
                    title={"My profile"}
                    body={
                        <ProfileForm
                            handleProfileClick={handleProfileClick}
                            userData={profileInfo}
                        />
                    }
                    maxWidth="800px"
                /> */}

            </div>
        </div>
    );
};

export default Header;
